module.exports = __webpack_public_path__ + "static/media/game_form.a9f9487a.pdf";